export const TEAMS_BASE_QUERY_KEY = 'Teams'
